import React, { useState, useCallback } from 'react'
import styled from 'styled-components'
import { CircularProgress } from '@mui/material'

import { ColourButton, Text, Spacer, icons } from 'portal/lib/primitives'
import { sizes } from '@qflow/theme'
import { useMixpanelEvents } from './mixpanel'
import { Report } from 'portal/store/insights/types'

interface ReportEventCellProps {
  item: Report
  noDownload?: boolean
}

export function ReportEventCell({
  item,
  noDownload = false
}: ReportEventCellProps) {
  const [downloading, setDownloading] = useState(false)
  const { trackDownload } = useMixpanelEvents()

  const handleDownload = useCallback(() => {
    if (item.readSASUrl && !noDownload) {
      setDownloading(true)
      trackDownload(
        item.reportName || '',
        item.reportType || '',
        item.projectId ?? undefined,
        item.projectName ?? undefined
      )
      window.open(item.readSASUrl, '_blank')
      // Reset downloading state after a short delay
      setTimeout(() => setDownloading(false), 1000)
    }
  }, [
    item.readSASUrl,
    item.reportName,
    item.reportType,
    item.projectId,
    item.projectName,
    noDownload,
    trackDownload
  ])

  return !noDownload && item.readSASUrl ? (
    <ColourButton.Trigger
      style={{ margin: '0', display: 'inline-flex' }}
      onClick={handleDownload}
      disabled={downloading}
    >
      {downloading ? (
        <CircularProgress size={sizes.LARGER} thickness={5} color={'inherit'} />
      ) : (
        <icons.Download />
      )}

      <Spacer.Fine />

      <StatusText>Download</StatusText>
    </ColourButton.Trigger>
  ) : null
}

const StatusText = styled(Text)`
  color: inherit;
  min-width: 4rem;
  display: inline-block;
`
